<template>
    <v-container fluid>
        <v-form
            ref="form"
            v-model="validForm"
            lazy-validation
        >
            <v-row>
                <v-col 
                    style="display: flex; align-content: center; align-items: center;"
                    cols="12"
                    lg="12"
                    md="12"
                    sm="12"
                >
                    <h3>Tutorial</h3>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <hr />
                </v-col>
            </v-row>
            <v-row style="height: 100px">
                <v-col 
                    cols="12"
                    lg="6"
                    md="6"
                    sm="12"
                >
                    <label>Topic</label>
                    <v-text-field
                        v-model="tutorialRequest.topic" 
                        :rules=[validations.required]
                        single-line
                        outlined
                        dense
                    >
                    </v-text-field>
                </v-col>

                <v-col cols="12"
                    lg="6"
                    md="6"
                    sm="12"
                >
                    <label>Profile you will view</label>
                    <v-combobox
                        v-model="tutorialRequest.profileSelected"
                        :items="listProfile"
                        item-text="name"
                        item-value="id"
                        clearable
                        outlined
                        dense
                    ></v-combobox>
                </v-col>
            </v-row>
            <v-row>
                <v-col 
                    style="margin-top: 20px;"
                    cols="12"
                    lg="12"
                    md="12"
                    sm="12"
                >
                    <ContentHeader :description="'Items'" />
                </v-col>
            </v-row>
            <v-row>
                <v-col 
                    cols="3"
                    lg="3"
                    md="3"
                    sm="3"
                >
                    <label>Description</label>
                </v-col>
                <v-col 
                    cols="3"
                    lg="3"
                    md="3"
                    sm="3"
                >
                    <label>Url</label>
                </v-col>
                <v-col 
                    cols="4"
                    lg="4"
                    md="4"
                    sm="4"
                >
                    <label>Documents</label>
                </v-col>
            </v-row>
            <v-row v-for="(item, index) in tutorialRequest.listItem" :key="index" style="height: 100px;" >
                <v-col 
                    cols="3"
                    lg="3"
                    md="3"
                    sm="3"
                >
                    <v-textarea
                        v-model="item.description"
                        single-line
                        rows="2"
                        row-height="20"
                        outlined
                    >
                    </v-textarea>
                </v-col>
                <v-col 
                    cols="3"
                    lg="3"
                    md="3"
                    sm="3"
                >
                    <!-- <v-textarea
                        v-model="item.url"
                        single-line
                        rows="3"
                        row-height="30"
                        outlined
                    >
                    </v-textarea> -->
                    <v-text-field
                        v-model="item.url" 
                        single-line
                        outlined
                    >
                    </v-text-field>
                </v-col>
                <v-col 
                    cols="4"
                    lg="4"
                    md="4"
                    sm="4"
                >
                    <v-file-input
                        v-model="item.filesDocs" 
                        accept=".pdf"
                        small-chips
                        multiple
                        outlined
                        placeholder="Click here to add"
                        prepend-inner-icon="mdi-paperclip"
                        prepend-icon=""
                        @change="resizePreviewImage(item.filesDocs, item.docs)"
                    ></v-file-input>
                </v-col>
                <v-col 
                    cols="2"
                    lg="1"
                    md="2"
                    sm="2"
                    :class="item.showAddNewItem != true ? 'colButtonList' : 'colButtonList2'"
                >
                    <v-tooltip top v-if="item.showAddNewItem == true" style="padding-bottom: 5px;">
                        <template v-slot:activator="{ on }">
                            <v-btn 
                                class="btnActions"
                                outlined
                                fab
                                x-small
                                v-on="on"
                                @click="addNewItem(item)" 
                                color="blue" 
                                small
                                :key="index"
                            >
                                <v-icon>mdi-plus</v-icon>
                            </v-btn>
                        </template>
                        <span>Add New Item</span>
                    </v-tooltip>
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-btn 
                                class="btnActions"
                                outlined
                                fab
                                x-small
                                v-on="on"
                                @click="deleteItem(index)" 
                                color="red" 
                                small
                                :disabled="tutorialRequest.listItem.length <= 1"
                            >
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </template>
                        <span>Delete Item</span>
                    </v-tooltip>
                </v-col>
            </v-row>
            
            <br />

            <ActionButtons
                :request="tutorialRequest"
                :loading="loading"
                :showButtons="{
                    cancel: true,
                    save: true
                }"
                @cancel="cancel"
                @save="save"
            />
        </v-form>

    </v-container>
</template>

<script>
    import ContentHeader from "@/components/Layout/ContentHeader.vue";
    import { required } from "@/utilities/Rules";
    import Helpers from '@/utilities/Helpers';
    import ActionButtons from "@/components/Layout/ActionButtons";
    import { 
        TYPE_DOCUMENT, 
        TYPE_ATTACHMENT 
    } from "@/utilities/Enums";

    export default ({

        mixins: [Helpers],

        components: {
            ContentHeader,
            ActionButtons
        },

        data: () => ({

            validForm: true,

            tutorialRequest: {
                id: 0,
                profileSelected: null,
                topic: '',
                listItem: []
            },

            listProfile: [],

            loading: false,
            
            validations: {
                required: required,
            }
        }),

        props: {
            id: {
                default: 0
            }
        },

        methods: {
            
            async deleteItem(index) {
                this.tutorialRequest.listItem.splice(index, 1);
                
                const lastIndex = this.tutorialRequest.listItem.length - 1;

                this.tutorialRequest.listItem[lastIndex].showAddNewItem = true;
            },

            async addNewItem(itemAtual) {

                if (itemAtual !== null && itemAtual !== undefined) {
                    itemAtual.showAddNewItem = false;
                }

                this.tutorialRequest.listItem.push({
                    description: null,
                    url: null,
                    showAddNewItem: true
                })
            },
            
            async getRegister() {

                if (this.id !== 0) {

                    const response = await this.$store.dispatch("tutorialModule/GetById", this.id);

                    if (response.success) {
                        this.tutorialRequest = response.result;

                        if (this.tutorialRequest.listItem.length == 0) {
                            await this.addNewItem();
                        }

                        this.tutorialRequest.listItem.forEach(async item => {
                            const listAttachments = await this.$store.dispatch("attachmentModule/GetAll", { typeAttachment: TYPE_ATTACHMENT.TUTORIAL.value, idKey: item.id }); 
      
                            const listDocs = listAttachments.filter(atc => atc.typeDocument == TYPE_DOCUMENT.DOCUMENTS.value);

                            item.filesDocs = [];
                            item.docs = [];
                            
                            listDocs.forEach(itemDoc => {

                                item.filesDocs.push(new File([], itemDoc.fileName));

                                item.docs.push({
                                    idAttachment: itemDoc.id,
                                    file: new File([], itemDoc.fileName),
                                    type: itemDoc.fileType,
                                    fileName: itemDoc.fileNameShort,
                                    deleted: false
                                })
                            })

                            this.$forceUpdate();
                        })
                    }
                }
                else {
                    await this.addNewItem();

                    this.tutorialRequest.listItem.forEach( item => {
                        item.filesDocs = [];
                        item.docs = [{
                            idAttachment: 0,
                            deleted: false
                        }];
                    })
                }

                console.log('this.tutorialRequest.listItem', this.tutorialRequest.listItem);
            },

            async getLists() {
                
                const itemAllProfiles = {
                    id: 0,
                    name: 'All Profiles'
                }
                
                this.listProfile = await this.$store.dispatch("profileModule/List");
                this.listProfile.unshift(itemAllProfiles);

                if (this.tutorialRequest.profileSelected == null || this.tutorialRequest.profileSelected == undefined) {
                    this.tutorialRequest.profileSelected = itemAllProfiles;
                }
            },

            async cancel() {
                this.$router.push({ path: "/tutorial/tutorialList" });
            },

            async uploadFiles(id, idKey, file, typeDocument, deleted = false) {

                let attachmentRequest = {
                    id: id,
                    idKey: idKey,
                    file: file ? file : new Blob(),
                    fileName: file ? file.name : "",
                    fileType: file ? file.type : "",
                    fileSize: file ? file.size : 0,
                    deleted: deleted ? deleted : false,
                    typeAttachment: TYPE_ATTACHMENT.TUTORIAL.value,
                    typeDocument: typeDocument,
                }

                if (attachmentRequest.fileName != null && attachmentRequest.fileName != undefined) {
                    let attachmentFileRequest = new FormData();

                    attachmentFileRequest.append("attachmentRequest", JSON.stringify(attachmentRequest));
                    attachmentFileRequest.append("attachmentFile", attachmentRequest.file, attachmentRequest.fileName);

                    const result = await this.$store.dispatch("attachmentModule/CreateUpdate", { 
                        attachmentFileRequest, 
                        id: 0
                    });

                    return result;
                }
                else {
                    return {
                        success: true
                    };
                }
            },

            async saveDocuments() {
                const cloneItems = [...this.tutorialRequest.listItem];

                await this.getRegister();

                let index = 0
                cloneItems.forEach(async itemClone => {
                    const item = this.tutorialRequest.listItem[index];
                    index++;
                    
                    let allResult = []

                    itemClone.docs.forEach(async itemDoc => {

                        const result = await this.uploadFiles(itemDoc.idAttachment ?? 0, item.id, itemDoc.file, TYPE_DOCUMENT.DOCUMENTS.value, itemDoc.deleted);

                        if (result.success == false) {
                            allResult.push({
                                typeDocument: TYPE_DOCUMENT.DOCUMENTS.description,
                                message: result.message
                            })
                        }
                    })

                    if (allResult.length > 0) {
                        let message = ""

                        await allResult.forEach(itemResult => {
                            message += `Error to upload docs: [${itemResult.message}] \n`;
                        })

                        this.showToast("error", "Warning!", message);

                        return false;
                    }
                    else {
                        return true;
                    }
                });
            },

            async save() {

                await this.$refs.form.validate();

                if (this.validForm === false) {
                    this.showToast("error", "Warning!", "There are inconsistencies in the form. Please review!");
                    return false;
                }
                else {

                    this.loading = true;
                    this.showLoading();

                    if (this.tutorialRequest.profileSelected != null && this.tutorialRequest.profileSelected != undefined) {
                        this.tutorialRequest.idProfile = this.tutorialRequest.profileSelected.id
                    }
                    else {
                        this.tutorialRequest.idProfile = 0
                    }

                    this.tutorialRequest.id = this.id;

                    const result = await this.$store.dispatch("tutorialModule/CreateUpdate", this.tutorialRequest);

                    if (result.success === true) {
                        this.showToast("success", "Success!", result.message);
                        await this.saveDocuments();
                        this.cancel();
                    }
                    else {
                        this.showToast("error", "Warning!", result.message);
                    }

                    this.loading = false;
                    this.hideLoading();
                }
            }
        },

        created() {
            this.showLoading();

            this.getLists();
            this.getRegister();

            this.hideLoading();
        }
    })
</script>

<style scoped>

    div[class^='col-'] {
        padding-top: 2px;
        padding-bottom: 2px;
    }

    .colButtonList {
        padding-top: 12px;    
    }

    .colButtonList2 {
        margin-top: inherit;
    }
    
    .btnToogleNoAccess {
        background-color: transparent !important; 
        color: var(--color__red) !important;
    }
    
    .btnToogleReadOnly {
        background-color: transparent !important; 
        color: var(--color__cinza_escuro) !important;
    }

    .marginPadding {
        padding: 10px;
    }

    @media only screen and (max-width: 647px) {
        .colButtonList {
            margin-top: -30px;
            display: flex;
            align-items: center;
        }

        .colButtonList2 {
             margin-top: -8px;
        }

        .btnActions {
            margin-bottom: 5px;
        }
    }
</style>